<div (keydown)="handleKeydown($event)" class="message-modal" *ngIf="pageJson">
    {{loadFocusTelements()}}
    <div class="modal-header">
        <h2 id="modalHeading" tabindex="0">{{pageJson.heading}}</h2>
    </div>
    <div class="corner-button">
        <button class="close" aria-label="Close" (click)="dimissModal(false)" (keydown)="dimissModal(false, $event)">x</button>
    </div>
    <div class="modal-body box-outer" [formGroup]="messageForm">
        <div *ngIf="showError" class="alert valign-children-middle error-container" >
            <div class="alert-error">
                <i class="icon-badgealert" role="alert" aria-label="Alert" tabindex="0"></i>
            </div>
            <div>{{pageJson.error.heading}}<span class="message">{{pageJson.error.subHeading}}</span></div>
        </div>
        <p>{{pageJson.description}}</p>
        <p>{{pageJson.selectedCTN}}  {{ctnDetails.ctn}}</p>
        <div class="form-group">
            <label for="messageText">Message
                <textarea class="form-control" formControlName="text" id="messageText" maxlength=140 #messageText></textarea>
                <span>{{messageService.computeLength(messageText.value)}} of 140 characters</span>
            </label>
        </div>
    </div>
    <div class="text-right modal-footer row">
        <button class="btn btn-secondary col-md-5 col-sm-12 pull-right" id="message-modal-btn" [checkImpersonator]="!messageText.value.length" (click)="next(messageText.value)" (keydown)="next(messageText.value, $event)" tabindex="0" [attr.aria-label]="pageJson.cta.next">{{pageJson.cta.next}}</button>
        <a href="javascript:void(0);" class="btn btn-link btn-block col-sm-12 btn-cancel pull-right text-right cancel-button-modal" (click)="dimissModal(false)" (keydown)="dimissModal(false, $event)"><span>{{pageJson.cta.back}}</span></a>
    </div>
</div>